import React, { Component } from 'react'
import * as Yup from 'yup'
import NumberFormat from 'react-number-format'
import Step1 from './Step1'
import moment from 'moment-jalaali' // Notice here !
import { MdPrint } from 'react-icons/md'
import RegistrationPrint from '../Callback/RegistrationPrint'

import { config } from '../config'
const base_url = config.apiBaseUrl
function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}

class ConnectToBankForm extends Component {
  state = {
    currentStep: 0,
    lastStep: 0,
    data: this.props.memberInfos ? this.props.memberInfos : [],
    transferToBankLoading: undefined
  }

  prevStep = props => {
    // Prev Step dont undes 0
    this.setState(state => ({
      currentStep: Math.max(state.currentStep - 1, 0)
    }))
    props.setTouched({})
  }

  nextStep = props => {
    // console.log(props.values)

    // Next Step dont go over Max step
    // console.log(props.errors)
    // props.submitForm().then(() => {
    if (props.isValid) {
      this.setState(state => ({
        currentStep: Math.min(state.currentStep + 1, state.lastStep)
      }))
      // props.validateForm();
      props.setTouched({})
    }
    // });
  }

  Step1Schema = Yup.object().shape({
    unionId: Yup.string().required('اتحادیه'),

    nationalCode: Yup.string()
      .matches(/^[0-9]\d{9}$/, {
        message: 'کد ملی باید شامل 10 رقم باشد',
        excludeEmptyString: false
      })
      .required('وارد کردن [کد ملی] الزامی است')
  })

  schemaArray = [this.Step1Schema, this.Step2Schema, this.Step3Schema]

  // handleSubmit = (values, formikbag) => {
  //   // do stuff
  //   setTimeout(() => {
  //     formikbag.setSubmitting(false);
  //   }, 1000);
  // };

  step1 = props => {
    if (this.state.currentStep == 0) {
      return (
        <div>
          <Step1 {...props} />
          {/* <br/>
          <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
            مرحله بعد
          </button> */}
        </div>
      )
    }
  }

  //   step2 = props => {
  //     if (this.state.currentStep == 1) {
  //       return (
  //         <div>
  //         <Step2 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
  //             مرحله بعد
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //             مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  //   step3 = props => {
  //     if (this.state.currentStep == 2) {
  //       return (
  //         <div>
  //         <Step3 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" type="submit">
  //             ذخیره
  //           {props.isSubmitting &&
  //                     <i className="mdi mdi-24px mdi-spin mdi-loading"></i>
  //                     }
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //           مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  handleSubmit = values => {
    // console.log(JSON.stringify(values))
    // memberService.add(JSON.stringify(values))
    //   .then((res) => {
    //     console.log(res);
    //     // this.setState({ loading: false, modal: false });
    //     //   toastr.success('ثبت برند جدید', 'برند جدید  "' + values.name + '" با موفقیت ثبت شد');
    //   }).catch((error) => { console.log(error) });
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);

    if (nextProps.memberInfos !== this.props.memberInfos) {
      this.setState({ data: nextProps.memberInfos })
    }
  }

  handleTransferToBank = id => {
    this.setState({ transferToBankLoading: id })

    window.location.assign(base_url + 'bank/TransferToBank/' + id)
  }

  handlePrintRegistration = () => {
    this.setState({ showRegistrationPrintDialog: true })
  }

  render() {
    const { currentStep, data, transferToBankLoading } = this.state
    const { prevStep, nextStep, schemaArray } = this
    return (
      data.length > 0 && (
        <div className="connectToBankForm">
          <h1>ﭘﺮداﺧﺖ آﻧﻼﯾﻦ ﻫﺰﯾﻨﻪ ﮐﻼس</h1>
          <p>
            {data[0].gender === 0 ? 'جناب آقای ' : 'سرکار خانم '}
            <span>{data[0].firstName + ' ' + data[0].lastName}</span>
          </p>
          <p>اطلاعات شما در سامانه ثبت شد. </p>
          <p>
            جهت تکمیل ثبت نام، لطفا هزینه کلاس آموزشی را بصورت آنلاین پرداخت
            نمائید.
          </p>

          <table className="table table-striped table-hover  text-center table-bordered table-canvas">
            <thead>
              <tr>
                <th>#</th>
                <th>نام کلاس</th>
                <th>تاریخ برگزاری کلاس</th>
                <th>اتحادیه</th>
                <th>کد رهگیری</th>
                <th>هزینه کلاس</th>
                <th>پرداخت</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>
                    {item.currentClass &&
                      item.currentClass.lesson &&
                      item.currentClass.lesson.name}
                  </td>
                  <td>{formatDefaultValue(item.currentClass.startDateTime)}</td>
                  <td>{item.union.name}</td>
                  <td>{item.trackId}</td>
                  <td>
                    {item.currentClass.amount ? (
                      <NumberFormat
                        thousandSeparator={true}
                        className="numberFa"
                        value={item.currentClass.amount}
                        displayType="text"
                        suffix=" ریال"
                      />
                    ) : (
                      'رایگان'
                    )}
                  </td>
                  <td>
                    <RegistrationPrint
                      data={item}
                      show={this.state.showRegistrationPrintDialog}
                      onClose={() =>
                        this.setState({ showRegistrationPrintDialog: false })
                      }
                    />
                    {item.union && item.union.creditPayment ? (
                      <a
                        onClick={() => this.handlePrintRegistration()}
                        className="flex-row-icon-link">
                        <span> مشاهده و چاپ رسید </span>
                        <MdPrint
                          size="24px"
                          style={{ verticalAlign: 'middle' }}
                        />
                      </a>
                    ) : item.currentClass.amount === 0 ? (
                      <div>-</div>
                    ) : item.paymentStatus === 0 ? (
                      <a
                        className="paymentBtn"
                        onClick={() => this.handleTransferToBank(item.id)}
                        disabled={transferToBankLoading === item.id}>
                        {transferToBankLoading === item.id ? (
                          <span>
                            <i className="mdi  mdi-spin mdi-loading" /> در حال
                            اتصال به درگاه بانک
                          </span>
                        ) : (
                          <span>پرداخت آنلاین</span>
                        )}
                      </a>
                    ) : item.paymentStatus === 1 ? (
                      <span>پرداخت شده</span>
                    ) : (
                      ''
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <p className="rtl">
          در حال اتصال به درگاه بانکی
                    <br />
          <i className="mdi  mdi-spin mdi-loading"></i>              لطفا منتظر بمانید ...
            </p> */}
        </div>
      )
    )
  }
}

export default ConnectToBankForm
